import React from 'react';
import { OverviewModel } from '../models/overview';

// eslint-disable-next-line import/prefer-default-export
export const OverviewContext = React.createContext<OverviewModel>({} as OverviewModel);
